const getData = () => {
  return [
    {
      id: 1,
      title: "Front-End Web Developer Expert",
      date: "03 Desember 2022",
      issuer: "Dicoding Academy",
      imageUrl: "/images/sertifikat/expert.png",
      link: "https://www.dicoding.com/certificates/ERZR0WJQNXYV",
    },
    {
      id: 2,
      title: "Fundamental Front-End Web",
      date: "19 September 2022",
      issuer: "Dicoding Academy",
      imageUrl: "images/sertifikat/fundamental.png",
      link: "https://www.dicoding.com/certificates/NVP7KRWEGZR0",
    },
    {
      id: 3,
      title: "Front-End Web Developer Pemula",
      date: "29 Agustus 2022",
      issuer: "Dicoding Academy",
      imageUrl: "images/sertifikat/pemula.png",
      link: "https://www.dicoding.com/certificates/ERZRMV0WQPYV",
    },
    {
      id: 4,
      title: "Fundamental Front-End React",
      date: "18 Oktober 2022",
      issuer: "Dicoding Academy",
      imageUrl: "images/sertifikat/fundamentalReact.png",
      link: "https://www.dicoding.com/certificates/QLZ9284N7X5D",
    },
    {
      id: 5,
      title: "Aplikasi Web React",
      date: "30 September 2022",
      issuer: "Dicoding Academy",
      imageUrl: "images/sertifikat/pemulaReact.png",
      link: "https://www.dicoding.com/certificates/MRZMD0OMRZYQ",
    },
    {
      id: 6,
      title: "Dasar Pemrograman Web",
      date: "29 Agustus 2021",
      issuer: "Dicoding Academy",
      imageUrl: "images/sertifikat/dasarWeb.png",
      link: "https://www.dicoding.com/certificates/MEPJEOWOLX3V",
    },
    {
      id: 7,
      title: "Dasar Git dengan Github",
      date: "4 Agustus 2022",
      issuer: "Dicoding Academy",
      imageUrl: "images/sertifikat/github.png",
      link: "https://www.dicoding.com/certificates/0LZ01ND83P65",
    },
    {
      id: 8,
      title: "Dasar Logika Pemrograman",
      date: "3 Agustus 2022",
      issuer: "Dicoding Academy",
      imageUrl: "images/sertifikat/logika.png",
      link: "https://www.dicoding.com/certificates/4EXG5JD8EXRL",
    },
    {
      id: 9,
      title: "Dasar Pemrograman",
      date: "3 Agustus 2022",
      issuer: "Dicoding Academy",
      imageUrl: "images/sertifikat/dasarPemrograman.png",
      link: "https://www.dicoding.com/certificates/07Z6RQ1LJPQR",
    },
    {
      id: 10,
      title: "Responsive Web Design ",
      date: "10 Juni 2021",
      issuer: "Free Code Camp",
      imageUrl: "images/sertifikat/responsiveWeb.png",
      link: "https://www.freecodecamp.org/certification/AldoWijaya/responsive-web-design",
    },
    {
      id: 11,
      title: "Website Design and Build",
      date: "3 Oktober 2021",
      issuer: "Kampus Merdeka",
      imageUrl: "images/sertifikat/kmmi.png",
      link: "https://drive.google.com/file/d/1G2aEgEAe9Yxls6EbLNxhODYAV-2-xPH-/view?usp=sharing",
    },
  ];
};

export { getData };
